import './logOut.css';

export default function logOut({ logOut }) {
    return (
        <button type="button" className="btn btn-sm btn-danger steward__logOut" onClick={logOut}>Sign Out</button>
    );
}